export default {
  type: 'datetime',
  label: 'Data/hora',
  shape: 'circle'
}